import { Link } from "react-router-dom";
import { storeLoginResume } from "@/lib/loginResume";

const DISCLAIMER =
  "Try our free online quiz. Additional Academy access is available with eligible driving-lesson bookings. Access conditions apply. Instructor activation is required for advanced access. All over Auckland.";

export default function PathwayLanding({ testId, title, lead, returnPath, interest }) {
  const registerTo = interest
    ? `/register?interest=${encodeURIComponent(interest)}&return=${encodeURIComponent(returnPath)}`
    : `/register?return=${encodeURIComponent(returnPath)}`;

  return (
    <div className="space-y-8" data-testid={testId}>
      <section className="hero-card space-y-4">
        <h1 className="text-3xl font-bold">{title}</h1>
        <p className="text-base max-w-2xl">{lead}</p>
        <p className="text-sm text-muted-foreground max-w-2xl">{DISCLAIMER}</p>
        <div className="flex flex-wrap gap-3">
          <Link
            to={registerTo}
            className="btn-accent"
            onClick={() => storeLoginResume(returnPath)}
          >
            Create account
          </Link>
          <Link to="/login" className="btn-outline-light" onClick={() => storeLoginResume(returnPath)}>
            Log in
          </Link>
        </div>
      </section>
    </div>
  );
}
